// MoreDropdownItem Component - Pure MUI
import { ListItemIcon, ListItemText, MenuItem } from '@mui/material';

interface MoreDropdownItemProps {
  label: string;
  icon: React.ReactNode;
  onClick: () => void;
}

export const MoreDropdownItem = ({ label, icon, onClick }: MoreDropdownItemProps) => {
  return (
    <MenuItem
      onClick={onClick}
      sx={{
        py: 1.5,
        px: 2,
        borderRadius: 1,
        mx: 0.5,
        my: 0.25,
        '&:hover': {
          bgcolor: 'action.hover',
        },
        '&:active': {
          bgcolor: 'action.selected',
        },
      }}
    >
      <ListItemIcon sx={{ minWidth: 40, color: 'text.secondary' }}>{icon}</ListItemIcon>
      <ListItemText
        primary={label}
        primaryTypographyProps={{
          fontSize: '0.9375rem',
          fontWeight: 500,
          color: 'text.primary',
        }}
      />
    </MenuItem>
  );
};

export default MoreDropdownItem;
